<template>
  <div class="product-category">
    <el-button style="margin-bottom: 20px;" type="primary" @click="openDialog()">新增产品类别</el-button>

    <el-table :data="productCategories" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="序号" ></el-table-column>
      <el-table-column prop="name" label="产品类别名称"></el-table-column>
      <!-- 父级目录 -->
      <el-table-column prop="pid" label="父级目录">
        <!-- slot 查找 -->
        <template slot-scope="scope">
          <span v-if="!scope.row.pid">顶级目录</span>
          <span v-else>{{productCategories.find(item=>item.id===scope.row.pid).name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order" label="排序"></el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="openUpdateDialog(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="title" :visible.sync="dialogVisible">
      <el-form :model="newProductCategory">
        <el-form-item label="产品类别名称" :label-width="formLabelWidth">
          <el-input v-model="newProductCategory.name"></el-input>
        </el-form-item>
        <!-- 父级id pid -->
        <el-form-item label="父级目录" :label-width="formLabelWidth">
          <!-- <el-input v-model="newProductCategory.pid" type="number"></el-input> -->
          <!-- select -->
          <el-select v-model="newProductCategory.pid" placeholder="请选择">
            <el-option
              v-for="item in productCategories"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="newProductCategory.order"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOk()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      title: '新增产品类别',
      productCategories: [],
      newProductCategory: {},
      formLabelWidth: "120px",
      dialogVisible: false
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.newProductCategory = {};
      this.title = '新增产品类别';
    },
    loadProductCategories() {
      this.loading = true;
      this.$http.get('Product/ProductCategories')
        .then(response => {
          this.productCategories = response.result;
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    handleOk(){
      // 如果有pid 转为数字
      if (this.newProductCategory.pid) {
        this.newProductCategory.pid = parseInt(this.newProductCategory.pid);
      }
      if (this.newProductCategory.id) {
        this.updateProductCategory(this.newProductCategory);
      } else {
        this.createProductCategory();
      }
    },
    // 删除，需要有提示
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该产品类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`Product/ProductCategories/${row.id}`)
          .then(response => {
            if (response.errorCode===200) {
              this.$message({
                message: '删除产品类别成功',
                type: 'success'
              });
              this.loadProductCategories();
            }else{
              this.$message({
                message: response.result,
                type: 'error'
              });
            }
          })
          .catch(error => {
            // 提示错误
            if (error.response.data.result) {
              this.$message({
                message: error.response.data.result,
                type: 'error'
              });
            } else {
              this.$message({
                message: '删除产品类别失败',
                type: 'error'
              });
            }
            // Handle error here, e.g. show an error message
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    createProductCategory() {
      this.$http.post('Product/ProductCategories', this.newProductCategory)
        .then(response => {
          if (response.errorCode===200) {
            this.dialogVisible = false;
            this.$message({
              message: '新增产品类别成功',
              type: 'success'
            });
            this.loadProductCategories();
          }
        })
        .catch(error => {
          console.error(error);
          // Handle error here, e.g. show an error message
        });
    },
    openUpdateDialog(productCategory) {
      this.newProductCategory = Object.assign({}, productCategory);
      this.title = '编辑产品类别';
      this.dialogVisible = true;
    },
    updateProductCategory(productCategory) {
      this.$http.put(`Product/ProductCategories/${productCategory.id}`, productCategory)
        .then(response => {
          if (response.errorCode===200) {
            this.$message({
              message: '更新产品类别成功',
              type: 'success'
            });
            this.loadProductCategories();
          }
        })
        .catch(error => {
          console.error(error);
          // Handle error here, e.g. show an error message
        });
    }
  },
  mounted() {
    this.loadProductCategories();
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>